/**
 * RISALTI - Product FAQ
 *
 * Mantiene aperta una sola FAQ interna alla volta.
 */

(function () {

  function initRisaltiProductFaq() {

    const faqGroups = document.querySelectorAll('.risalti-product-faq');

    if (!faqGroups.length) {
      return;
    }

    faqGroups.forEach(function (faqGroup) {

      if (faqGroup.dataset.faqInitialized === 'true') {
        return;
      }

      faqGroup.dataset.faqInitialized = 'true';

      faqGroup.addEventListener(
        'toggle',
        function (event) {

          const currentItem = event.target;

          if (
            !currentItem.classList.contains('risalti-product-faq__item') ||
            !currentItem.open
          ) {
            return;
          }

          faqGroup
            .querySelectorAll('.risalti-product-faq__item[open]')
            .forEach(function (item) {

              if (item !== currentItem) {
                item.open = false;
              }

            });

        },
        true
      );

    });

  }


  /*
   * Primo caricamento pagina
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initRisaltiProductFaq
    );

  } else {

    initRisaltiProductFaq();

  }


  /*
   * Utile anche nel Theme Editor Shopify,
   * quando una sezione viene ricaricata dinamicamente.
   */
  document.addEventListener(
    'shopify:section:load',
    initRisaltiProductFaq
  );

})();